import _classCallCheck from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { __awaiter } from "tslib";
import { createOfflineAudioContext } from "../context/AudioContext";
import { Context } from "../context/Context";
import { isOfflineAudioContext } from "../util/AdvancedTypeCheck";
import { ToneAudioBuffer } from "./ToneAudioBuffer";
/**
 * Wrapper around the OfflineAudioContext
 * @category Core
 * @example
 * // generate a single channel, 0.5 second buffer
 * const context = new Tone.OfflineContext(1, 0.5, 44100);
 * const osc = new Tone.Oscillator({ context });
 * context.render().then(buffer => {
 * 	console.log(buffer.numberOfChannels, buffer.duration);
 * });
 */

export var OfflineContext = /*#__PURE__*/function (_Context) {
  _inherits(OfflineContext, _Context);

  var _super = _createSuper(OfflineContext);

  function OfflineContext() {
    var _this;

    _classCallCheck(this, OfflineContext);

    _this = _super.call(this, {
      clockSource: "offline",
      context: isOfflineAudioContext(arguments[0]) ? arguments[0] : createOfflineAudioContext(arguments[0], arguments[1] * arguments[2], arguments[2]),
      lookAhead: 0,
      updateInterval: isOfflineAudioContext(arguments[0]) ? 128 / arguments[0].sampleRate : 128 / arguments[2]
    });
    _this.name = "OfflineContext";
    /**
     * An artificial clock source
     */

    _this._currentTime = 0;
    _this.isOffline = true;
    _this._duration = isOfflineAudioContext(arguments[0]) ? arguments[0].length / arguments[0].sampleRate : arguments[1];
    return _this;
  }
  /**
   * Override the now method to point to the internal clock time
   */


  _createClass(OfflineContext, [{
    key: "now",
    value: function now() {
      return this._currentTime;
    }
    /**
     * Same as this.now()
     */

  }, {
    key: "currentTime",
    get: function get() {
      return this._currentTime;
    }
    /**
     * Render just the clock portion of the audio context.
     */

  }, {
    key: "_renderClock",
    value: function _renderClock(asynchronous) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var index, yieldEvery;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                index = 0;

              case 1:
                if (!(this._duration - this._currentTime >= 0)) {
                  _context.next = 11;
                  break;
                }

                // invoke all the callbacks on that time
                this.emit("tick"); // increment the clock in block-sized chunks

                this._currentTime += 128 / this.sampleRate; // yield once a second of audio

                index++;
                yieldEvery = Math.floor(this.sampleRate / 128);

                if (!(asynchronous && index % yieldEvery === 0)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 9;
                return new Promise(function (done) {
                  return setTimeout(done, 1);
                });

              case 9:
                _context.next = 1;
                break;

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Render the output of the OfflineContext
     * @param asynchronous If the clock should be rendered asynchronously, which will not block the main thread, but be slightly slower.
     */

  }, {
    key: "render",
    value: function render() {
      var asynchronous = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var buffer;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.workletsAreReady();

              case 2:
                _context2.next = 4;
                return this._renderClock(asynchronous);

              case 4:
                _context2.next = 6;
                return this._context.startRendering();

              case 6:
                buffer = _context2.sent;
                return _context2.abrupt("return", new ToneAudioBuffer(buffer));

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /**
     * Close the context
     */

  }, {
    key: "close",
    value: function close() {
      return Promise.resolve();
    }
  }]);

  return OfflineContext;
}(Context);